import { UserTokenType } from '^/types/userTypes';

import { TokenData } from './forServer';

export function extractTokenData(token: UserTokenType) {
  const body = token.split('.')[1];
  return JSON.parse(window.atob(body)) as TokenData;
}
